/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Additionalstudyinterests2Inputs */

const en__field_additionalstudyinterests2 = /** @type {(inputs: _Field_Additionalstudyinterests2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Additional Study Interests`)
};

const de__field_additionalstudyinterests2 = /** @type {(inputs: _Field_Additionalstudyinterests2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weitere Studiengänge`)
};

/**
* | output |
* | --- |
* | "Additional Study Interests" |
*
* @param {_Field_Additionalstudyinterests2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_additionalstudyinterests2 = /** @type {((inputs?: _Field_Additionalstudyinterests2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Additionalstudyinterests2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_additionalstudyinterests2(inputs)
	return de__field_additionalstudyinterests2(inputs)
});
export { _field_additionalstudyinterests2 as "_field_additionalStudyInterests" }